import { ACORIS_SOCIAL_REGIMES, SOCIAL_REGIMES } from "utils/constants";

export const SOCIAL_REGIME_FALLBACK_LABELS = {
  [SOCIAL_REGIMES.SECURITE_SOCIALE]: "Sécurité sociale",
  [SOCIAL_REGIMES.ALSACE_MOSELLE]: "Alsace / Moselle",
  [SOCIAL_REGIMES.REGIME_SPECIAL]: "Régime spécial",
  [SOCIAL_REGIMES.REGIME_SALARIES_AGRICOLES]: "Régime des salariés agricoles",
  [SOCIAL_REGIMES.SECURITE_SOCIALE_INDEPENDANTS]:
    "Sécurité sociale des indépendants",
  [ACORIS_SOCIAL_REGIMES.MSA_RL]: "Régime agricole Alsace / Moselle",
};

export const getSocialRegimeLabel = (key, labels = {}) =>
  labels[key] || SOCIAL_REGIME_FALLBACK_LABELS[key] || key;

export const mapSocialRegimeOptions = (regimes, labels = {}) =>
  Object.entries(regimes).map(([key, value]) => ({
    value,
    label: getSocialRegimeLabel(key, labels),
  }));
